module.exports = __webpack_public_path__ + "img/ipadpro_5th.0cc71476.jpg";